export default __webpack_public_path__ + "8e3730b5316ad69fbb7f12ffb8072fa2.png";